import {
  BaseApiParams as BP,
  BaseApiResponse as BR,
  BaseApiResponseCollection as BRC,
  CRUDInterface,
} from '@/typings/common'


export type TransformerD = <T, R extends BR<T | void>, P>(data: R, params?: P) => R
export type TransformerDAll = <TT, R extends BRC<TT>, P>(data: R, params?: P) => R

export class TransformerData<T, TT = T> implements CRUDInterface {
  protected readonly transformer?: TransformerD;

  protected readonly transformerAll?: TransformerDAll;

  public getAll<R extends BRC<TT> = BRC<TT>, P = BP>(response: R, params: P) {
    return this.toTransformAll<R, P>(response, params)
  }

  public getOne<R extends BR<T> = BR<T>, P = BP>(response: R, params: P) {
    return this.toTransform<R, P>(response, params)
  }

  public create<R extends BR<T | void> = BR<T | void>, P = BP>(response: R, params: P) {
    return this.toTransform<R, P>(response, params)
  }

  public update<R extends BR<T | void> = BR<T | void>, P = BP>(response: R, params: P) {
    return this.toTransform<R, P>(response, params)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
  public delete<R = BR<never>, P = BP>(response: R, params: P) {
    return response
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
  public deleteMultiple<R = BR<never>, P = BP>(response: R, params: P) {
    return response
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
  public updatePositions<R = BR<never>, P = BP>(response: R, params: P) {
    return response
  }

  // eslint-disable-next-line no-unused-vars
  protected toTransform<R extends BR<T | void> = BR<T | void>, P = BP>(response: R, params: P) {
    if (!this.transformer || !response) return response

    const result = this.transformer<T, R, P>(response, params)

    return result
  }

  protected toTransformAll<R extends BRC<TT> = BRC<TT>, P = BP>(response: R, params: P) {
    if (!this.transformerAll) return response

    const result = this.transformerAll<TT, R, P>(response, params)

    return result
  }
}
